import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from '../../../common/react-redux-hooks';

import { createNewDefinition } from '../../../../actions/definitionActions';
import { useACProjectContext } from '../../ACContext/ACDefinitionContext';

const DuplicateDefinition = ({ data, infoBoxRef }) => {
  const {
    moduleStudy,
    activeAccountId,
    definitionTarget,
  } = useACProjectContext();
  const dispatch = useDispatch();

  const patchDefinition = {
    token: '',
    ssid: moduleStudy.ss === 'SIMMONS' ? 1 : 2,
    accountId: activeAccountId,
    productNo: moduleStudy.pn,
    thisStudy: false,
    folderName: `Copy_${data.folderName}`,
    shared: false,
    newExpressions:
      definitionTarget && definitionTarget.data
        ? definitionTarget.data.map(({ title, expression }) => ({
            id: 0,
            name: title,
            expression,
          }))
        : [],
    sort: 'defSort=sc-a,ct-d',
  };

  const handleDuplicate = () => {
    dispatch(createNewDefinition(patchDefinition));
    infoBoxRef.current.targetRef.current.click();
  };

  return (
    <button
      type="button"
      className="autocode-duplicate-definition"
      data-test="definitionDuplicateComponent"
      onClick={() => handleDuplicate()}
    >
      Duplicate
    </button>
  );
};

DuplicateDefinition.propTypes = {
  data: PropTypes.shape({
    folderName: PropTypes.string,
  }),
  infoBoxRef: PropTypes.shape({
    current: PropTypes.shape({
      targetRef: PropTypes.shape({
        current: PropTypes.shape({
          click: PropTypes.func,
        }),
      }),
    }),
  }),
};

export default DuplicateDefinition;
